import { FC, useContext } from 'react';
import { useTitle } from 'react-use';

import { RouteTabs } from '@savgroup-front-common/core/atoms/RouteTabs';
import { buildPageTitle } from '@savgroup-front-common/core/helpers';
import { MyAccountIcon } from '@savgroup-front-common/core/protons/IconsNewDesign/MyAccount.icon';
import { ICONS_TYPE } from '@savgroup-front-common/types';
import BanneredLayout from '@/view/app/NewLayout/BanneredLayout/BanneredLayout';
import { InitContext } from '@/view/app/NewLayout/InitProvider/InitProvider.context';
import { PROFESSIONAL_STEP_CONFIG } from '@/view/app/NewLayout/ProfessionalRoutes.config';
import { buildProfessionalRoute } from '@/view/app/NewLayout/ProfessionalRoutes.helpers';

import { $HomeContentWrapper } from './HomePageProfessional.styles';
import useHomeTabs from './hooks/useHomeTabs';
import messages from './messages';

const HomePageProfessional: FC = () => {
  const { login, openedFiles, closedFiles } = useContext(InitContext);
  const { tabsConfig } = useHomeTabs({ openedFiles, closedFiles });

  useTitle(buildPageTitle([messages.professionalHomeTitlePage]));

  return (
    <BanneredLayout isHomePage>
      <BanneredLayout.BannerTitle
        title={{
          ...messages.bannerTitle,
          values: { userName: login?.firstName || '' },
        }}
        description={messages.bannerDescription}
        actions={[
          {
            label: messages.createFileButton,
            route: buildProfessionalRoute({
              route: PROFESSIONAL_STEP_CONFIG.PROFESSIONAL_ISSUES_REASONS_PAGE,
            }),
            icon: <MyAccountIcon icon={ICONS_TYPE.CONSUMABLE_ICON} />,
            primary: true,
          },
        ]}
      />

      <BanneredLayout.Content>
        <$HomeContentWrapper>
          <RouteTabs
            config={tabsConfig.map((tab) => ({
              ...tab,
              icon: <MyAccountIcon icon={tab.icon as ICONS_TYPE} />,
            }))}
            hasBottomBorder
            hideButton
            level={2}
          />
        </$HomeContentWrapper>
      </BanneredLayout.Content>
    </BanneredLayout>
  );
};

export default HomePageProfessional;
